import React from 'react';
import PropTypes from 'prop-types';
import { Button, utils } from '@resy/ui-kitchen';
import {
  DownloadAppleButton,
  DownloadGoogleButton,
} from '../../../svg';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME, RESY_APP_GOOGLE_PLAY } from '../../AmexMarketingUtils/constants';
import './AmexAppDownload.scss';

const AmexAppDownload = ({
  Analytics,
  awsFolderName,
  baseRequestUrl,
  appDownloadConfig,
}) => {
  const {
    title,
    app_store_url: appStoreUrl,
    google_play_url: googlePlayUrl,
    image_name: imageName,
  } = appDownloadConfig;

  return (
    <section className="AmexAppDownload">
      <div className="container">
        <div className="AmexAppDownload__inner">
          <img
            className="AmexAppDownload__device"
            src={`${baseRequestUrl}${awsFolderName}/images/${imageName}`}
            alt=""
          />
          <div className="AmexAppDownload__content">
            <h2 className="AmexAppDownload__title">{title}</h2>
            <div className="AmexAppDownload__store-wrapper">
              <Button
                variant="no-style"
                type="button"
                className="AmexAppDownload__store-link"
                aria-label="Download the Resy app from the App Store"
                onClick={() => {
                  const extraParams = {
                    action_name: 'App Download - Click',
                    item_name: 'App Store',
                  };
                  handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, extraParams);
                  utils.openExternalUrl(appStoreUrl, '_blank');
                }}
                data-link="download-link"
              >
                <i className="ResyIcon">
                  <DownloadAppleButton />
                </i>
              </Button>
              <Button
                variant="no-style"
                type="button"
                className="AmexAppDownload__store-link"
                aria-label={RESY_APP_GOOGLE_PLAY}
                onClick={() => {
                  const extraParams = {
                    action_name: 'App Download - Click',
                    item_name: 'Google Play',
                  };
                  handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, extraParams);
                  utils.openExternalUrl(googlePlayUrl, '_blank');
                }}
                data-link="download-link"
              >
                <span className="btn-label">{RESY_APP_GOOGLE_PLAY}</span>
                <i className="ResyIcon">
                  <DownloadGoogleButton />
                </i>

              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

AmexAppDownload.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  appDownloadConfig: PropTypes.shape({
    title: PropTypes.string,
    app_store_url: PropTypes.string,
    google_play_url: PropTypes.string,
    image_name: PropTypes.string,
  }).isRequired,
};

export default AmexAppDownload;
